/*
 * ItemAnalysisPage Messages
 *
 * This contains all the text for the ItemAnalysisPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.ItemAnalysisPage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Item Analysis',
  },
});
